<template>
	<layout-variant-two id="welcome-page" :footer-white="true" :active-menu-index="1">
		<template v-slot:body>
			<div class="welcome-wrapper">
				<div class="head-container">
					<BannerSlider/>
					<div class="head-copy" data-parallax-text="36">
						<h2>LIVE IN PURSUIT OF THE PEAK EXPERIENCE</h2>
						<div class="head-text">
							Driven by active living and mindful recovery, Peak Pursuits empowers enthusiasts to discover local wonders and push their limits from studio to sea to summit. It is a common ground for individuals to connect with the community, learn from experts, and cultivate a healthier lifestyle one experience at a time. 
						</div>
					</div>
					<div id="what-is-new"></div>
				</div>
				<div class="main-container">
					<CustomBlock/>
					<ExploreAdventure/>
					<PartnersBlock/>
					<JoinPursuits/>
					<ContactUs/>
				</div>
			</div>
		</template>
		<template v-slot:footer>
			<base-fnb-side-nav v-if="!loading" :active-index="1"/>
		</template>
	</layout-variant-two>
</template>

<script>
import LayoutVariantTwo from "@/components/layout/LayoutVariantTwo.vue";
import utility from "@/presentation/mixins/utility.js";
import BannerSlider from "./components/BannerSlider.vue";
import CustomBlock from "./components/CustomBlock.vue";
import PartnersBlock from "./components/PartnersBlock.vue";
import ContactUs from "./components/ContactUs.vue";
import ExploreAdventure from "./components/ExploreAdventure.vue";
import JoinPursuits from "./components/JoinPursuits.vue";

export default {
	name: "WelcomePage",
	components: {
		LayoutVariantTwo,
		BannerSlider,
		CustomBlock,
		PartnersBlock,
		ContactUs,
		ExploreAdventure,
		JoinPursuits,
	},
	mixins: [utility],
	data() {
		return {
			loading: true,
			isDesktop: true,
			serverInited: false,
		};
	},
	methods: {
		getScrollParent(element) {
			let parent = element && element.parentElement;
			while (parent) {
				const overflowY = window.getComputedStyle(parent).overflowY;
				if (overflowY === "auto" || overflowY === "scroll") return parent;
				parent = parent.parentElement;
			}
			return null;
		},
		updateParallax() {
			const viewH = window.innerHeight || document.documentElement.clientHeight;
			this.$el.querySelectorAll("[data-parallax]").forEach((frame) => {
				const media = frame.querySelector("video, img");
				if (!media) return;
				const rect = frame.getBoundingClientRect();
				if (rect.bottom < -120 || rect.top > viewH + 120) return;
				const progress = (viewH - rect.top) / (viewH + rect.height);
				const speed = Number(frame.dataset.parallax) || 0.15;
				const shift = (progress - 0.5) * rect.height * speed;
				const scale = media.tagName === "VIDEO" ? 1.25 : 1.2;
				media.style.transform = `translate3d(0, ${shift.toFixed(2)}px, 0) scale(${scale})`;
			});
			this.$el.querySelectorAll("[data-parallax-text]").forEach((frame) => {
				const rect = frame.getBoundingClientRect();
				if (rect.bottom < -120 || rect.top > viewH + 120) return;
				const progress = (viewH - rect.top) / (viewH + rect.height);
				const distance = Number(frame.dataset.parallaxText) || 24;
				const shift = (0.5 - progress) * distance;
				frame.style.transform = `translate3d(0, ${shift.toFixed(2)}px, 0)`;
			});
		},
		onParallaxScroll() {
			if (this.parallaxTicking) return;
			this.parallaxTicking = true;
			requestAnimationFrame(() => {
				this.updateParallax();
				this.parallaxTicking = false;
			});
		},
	},
	mounted() {
		this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
		if (this.prefersReducedMotion) return;
		this.parallaxScroller = this.getScrollParent(this.$el);
		window.addEventListener("scroll", this.onParallaxScroll, { passive: true });
		if (this.parallaxScroller) {
			this.parallaxScroller.addEventListener("scroll", this.onParallaxScroll, { passive: true });
		}
		this.updateParallax();
	},
	beforeUnmount() {
		window.removeEventListener("scroll", this.onParallaxScroll);
		if (this.parallaxScroller) {
			this.parallaxScroller.removeEventListener("scroll", this.onParallaxScroll);
		}
	},
	async created() {
		try {
			this.serverInited = this.$store.getters.isServerInited;
			this.loading = true;
			let hasInited = this.$store.getters.hasInited;
			if (!hasInited) {
				await this.refreshMainData(this.serverInited == true);
			}
		} catch (error) {
			console.log(error);
		} finally {
			this.loading = false;
		}
	}
};
</script>

<style scoped lang="scss">
#welcome-page {
	width: 100%;
	&.fade-out {
		animation-duration: 1s;
		animation-name: fadeout;
		animation-fill-mode: forwards;
	}
}

.welcome-wrapper {
	width: 100%;
	max-width: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	gap: 48px;
	padding-bottom: 48px;
}

@keyframes fadeout {
	0% {
		opacity: 1;
	}

	100% {
		opacity: 0;
	}
}

.head-container {
	padding-top: 20px;
	width: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
	gap: 32px;
	padding-bottom: 48px;
	background: $green-light;
	.head-copy {
		display: flex;
		flex-direction: column;
		gap: 32px;
	}
	h2 {
		font-family: 'Berthold Akzidenz Grotesk Medium';
		font-size: 2em;
		color: $blue-head;
		text-align: center;
		margin-top: 32px;
		line-height: normal;
	}
	.head-text {
		text-align: center;
		font-size: 16px;
		line-height: 22px;
		color: $secondary-color-100;
		padding-inline: 24px;
		max-width: 800px;
		margin-inline: auto;
	}
}
.main-container {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 48px;
	overflow: hidden;
	position: relative;
}
</style>
